function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import StarRatingReadOnly from './StarRatingReadOnly';
import StarRatingUpdateable from './StarRatingUpdateable';
/**
 * The StarRating component displays a set of star SVGs to visualize rating. StarRating
 * component can be read-only or updateable.
 *
 * ## Related Components
 * - [StarRatingReadOnly](../StarRatingReadOnly/README.md)
 * - [StarRatingUpdateable](../StarRatingUpdateable/README.md)
 *
 * ## Props
 */

var StarRating = function StarRating(props) {
  var readOnly = props.readOnly,
      otherProps = _objectWithoutProperties(props, ["readOnly"]);

  var className = otherProps.className,
      labelForRatings = otherProps.labelForRatings,
      maxValue = otherProps.maxValue,
      qa = otherProps.qa;
  if (maxValue !== labelForRatings.length) throw new Error('Max rating value and number of rating labels do not match!');
  var StarRatingComponent = readOnly ? StarRatingReadOnly : StarRatingUpdateable;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(className, 'psw-l-line-left'),
    "data-qa": qa
  }, /*#__PURE__*/React.createElement(StarRatingComponent, otherProps));
};

StarRating.defaultProps = {
  className: '',
  labelForRatings: ['1 star', '2 stars', '3 stars', '4 stars', '5 stars'],
  maxValue: 5,
  onRatingChange: function onRatingChange() {},
  name: 'productRating',
  qa: 'star-rating',
  readOnly: true,
  starSize: '5',
  value: 0
};
StarRating.propTypes = {
  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The label for the ratings
   */
  labelForRatings: PropTypes.arrayOf(PropTypes.string),

  /**
   * The max value of rating
   */
  maxValue: PropTypes.number,

  /**
   * The name used for the grouped radio buttons used for star rating
   */
  name: PropTypes.string,

  /**
   * Callback called when a new rating is selected (applicable to updateable star rating only)
   */
  onRatingChange: PropTypes.func,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Is rating read-only or can be updated
   */
  readOnly: PropTypes.bool,

  /**
   * The size of star icon to render
   */
  starSize: PropTypes.string,

  /**
   * The rating value
   */
  value: PropTypes.number
};
export default StarRating;